import React from "react";
import PropTypes from "prop-types";
import {
  Dropdown,
  DropdownMenu,
  DropdownHeader,
  DropdownDivider,
  Icon,
  Form,
  FormGroup,
  FormCheckbox,
  Button,
} from "semantic-ui-react";

import Constants from "./utilities/Constants";
import Strings from "./utilities/StringSelector";

const defaultColumns = {
  name: true,
  tag: true,
  mac: true,
  ip: true,
  alarms: true,
  faults: true,
  ping: true,
  lostPackets: true,
  availability: true,
  status: true
};

class ColumnsDropdown extends React.Component {
  state = {
    open: false,
    isNameCheckboxChecked: true,
    isTagCheckboxChecked: true,
    isMacCheckboxChecked: true,
    isIpCheckboxChecked: true,
    isAlarmsCheckboxChecked: true,
    isFaultsCheckboxChecked: true,
    isPingCheckboxChecked: true,
    islostPacketCheckboxChecked: true,
    isAvailabilityCheckboxChecked: true,
    isStatusCheckboxChecked: true,
  };

  open = () => this.setState({ open: true });
  close = () => this.setState({ open: false });

  toggleCheck = (e, { name }) => {
    e.stopPropagation();
    this.setState({ [name]: !this.state[name] });
  };

  handleSave = (e) => {
    e.stopPropagation();
    const activeColumns = {
      name: this.state.isNameCheckboxChecked,
      tag: this.state.isTagCheckboxChecked,
      mac: this.state.isMacCheckboxChecked,
      ip: this.state.isIpCheckboxChecked,
      alarms: this.state.isAlarmsCheckboxChecked,
      faults: this.state.isFaultsCheckboxChecked,
      ping: this.state.isPingCheckboxChecked,
      lostPackets: this.state.islostPacketCheckboxChecked,
      availability: this.state.isAvailabilityCheckboxChecked,
      status: this.state.isStatusCheckboxChecked
    };
    localStorage.setItem(Constants.LL_ACTIVE_COLUMNS, JSON.stringify(activeColumns));
    if (this.props.onChange) this.props.onChange(activeColumns);
    this.close();
  };

  componentDidMount() {
    let activeColumns = defaultColumns;
    try {
      activeColumns = {
        ...defaultColumns,
        ...JSON.parse(localStorage.getItem(Constants.LL_ACTIVE_COLUMNS) || "{}")
      };
    } catch (e) {
      activeColumns = defaultColumns;
    }
    this.setState({
      isNameCheckboxChecked: activeColumns.name,
      isTagCheckboxChecked: activeColumns.tag,
      isMacCheckboxChecked: activeColumns.mac,
      isIpCheckboxChecked: activeColumns.ip,
      isAlarmsCheckboxChecked: activeColumns.alarms,
      isFaultsCheckboxChecked: activeColumns.faults,
      isPingCheckboxChecked: activeColumns.ping,
      islostPacketCheckboxChecked: activeColumns.lostPackets,
      isAvailabilityCheckboxChecked: activeColumns.availability,
      isStatusCheckboxChecked: activeColumns.status
    });
  }

  render() {
    return (
      <Dropdown
        selection
        text={Strings.ACTIVE_COLUMNS}
        multiple
        open={this.state.open}
        onOpen={this.open}
        onClose={() => {}}
        closeOnChange={false}
        closeOnBlur={false}
        selectOnBlur={false}
        style={{ width: "235px" }}
        onClick={(e) => e.stopPropagation()}>
        <DropdownMenu
          style={{ width: "235px", maxHeight: "500px", overflowY: "scroll" }}
          onClick={(e) => e.stopPropagation()}>
          <div className="ui clearing basic segment" style={{ padding: "0.5rem 1rem" }}>
            <Icon name="close" link className="right floated" title={Strings.CLOSE} onClick={this.close} />
            <DropdownHeader icon="columns" content={Strings.ACTIVE_COLUMNS} />
          </div>

          <DropdownDivider />

          <Form
            style={{ margin: "8px" }}
            onSubmit={(e) => {
              e.preventDefault();
              e.stopPropagation();
              this.handleSave(e);
            }}>
            <FormGroup grouped>
              <FormCheckbox name="isNameCheckboxChecked" checked={this.state.isNameCheckboxChecked} label={Strings.NAME} onChange={this.toggleCheck} onClick={(e) => e.stopPropagation()} />
              <FormCheckbox name="isTagCheckboxChecked" checked={this.state.isTagCheckboxChecked} label={Strings.TAG} onChange={this.toggleCheck} onClick={(e) => e.stopPropagation()} />
              <FormCheckbox name="isMacCheckboxChecked" checked={this.state.isMacCheckboxChecked} label={Strings.MAC} onChange={this.toggleCheck} onClick={(e) => e.stopPropagation()} />
              <FormCheckbox name="isIpCheckboxChecked" checked={this.state.isIpCheckboxChecked} label={Strings.IP} onChange={this.toggleCheck} onClick={(e) => e.stopPropagation()} />
              <FormCheckbox name="isAlarmsCheckboxChecked" checked={this.state.isAlarmsCheckboxChecked} label={Strings.ALARMS} onChange={this.toggleCheck} onClick={(e) => e.stopPropagation()} />
              <FormCheckbox name="isFaultsCheckboxChecked" checked={this.state.isFaultsCheckboxChecked} label={Strings.FAULTS} onChange={this.toggleCheck} onClick={(e) => e.stopPropagation()} />
              <FormCheckbox name="isPingCheckboxChecked" checked={this.state.isPingCheckboxChecked} label={`${Strings.PING} ${Strings.ACTUAL_MEDIUM} (ms)`} onChange={this.toggleCheck} onClick={(e) => e.stopPropagation()} />
              <FormCheckbox name="islostPacketCheckboxChecked" checked={this.state.islostPacketCheckboxChecked} label={`${Strings.LOST_PACKET_PERC_1} ${Strings.LOST_PACKET_PERC_2}`} onChange={this.toggleCheck} onClick={(e) => e.stopPropagation()} />
              <FormCheckbox name="isAvailabilityCheckboxChecked" checked={this.state.isAvailabilityCheckboxChecked} label={Strings.AVAILABILITY} onChange={this.toggleCheck} onClick={(e) => e.stopPropagation()} />
              <FormCheckbox name="isStatusCheckboxChecked" checked={this.state.isStatusCheckboxChecked} label={Strings.STATUS} onChange={this.toggleCheck} onClick={(e) => e.stopPropagation()} />
            </FormGroup>
            <Button color="teal" fluid content={Strings.SAVE} type="submit" onClick={(e) => e.stopPropagation()} />
          </Form>
        </DropdownMenu>
      </Dropdown>
    );
  }
}

ColumnsDropdown.propTypes = {
  onChange: PropTypes.func
};

export { defaultColumns };
export default ColumnsDropdown;
